export * from "./eig";
export * from "./prenom";
export * from "./nom";
export * from "./email";
export * from "./personne";
export * from "./adresse";
export * from "./telephone";